import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Tooltip from '../../../ToolTip';
import { IconType } from 'react-icons/lib';

interface Props {
    messageIconOne:string;
    messageIconTwo?:string;
    messageIconThree?:string;
    IconOne: IconType;
    IconTwo?: IconType;
    IconThree?: IconType;
    onclickIconOne:()=>void;
    onclickIconTwo?:()=>void;
    linkTo?:string;
}

const ThreeIcons = ({
  messageIconOne,
  messageIconTwo,
  messageIconThree,
  IconOne,
  IconTwo,
  IconThree,
  onclickIconOne,
  onclickIconTwo,
  linkTo
}: Props): JSX.Element => {

  const [isCopied, setIsCopied] = useState(false)
  
  useEffect(() => {
    isCopied && setTimeout(() => {
      setIsCopied(false)
    }, 500);
  }, [isCopied])
  
  const actionIconOne = ()=>{
    setIsCopied(!isCopied);
    onclickIconOne()
  }
  const actionIconTwo = ()=>{
    setIsCopied(!isCopied);
    onclickIconTwo?.()
  }
  return (
    <>
      <div className="flex items-center gap-2">
        <Tooltip
          placement="bottom"
          bgColor="bg-black"
          textColor="text-white"
          tooltipClassName='!whitespace-nowrap'
          message={isCopied ?'Copied!' : messageIconOne}>
            <div>
              <IconOne className="text-black dark:text-darkBg-mainText" size={'19px'} cursor={'pointer'} onClick={()=>actionIconOne()} />
            </div>
        </Tooltip>

        {messageIconTwo && IconTwo && (
          <Tooltip
            placement="bottom"
            bgColor="bg-black"
            textColor="text-white"
            message={isCopied ?'Copied!' : messageIconTwo}>
              <div>
                <IconTwo className="text-black dark:text-darkBg-mainText" size={'19px'} cursor={'pointer'} onClick={()=>actionIconTwo()} />
              </div>
          </Tooltip>
        )}

        {messageIconThree && IconThree && linkTo && (
          <Tooltip
            placement="bottom"
            bgColor="bg-black"
            textColor="text-white"
            message={messageIconThree}>
            <Link to={linkTo} target="_blank">
              <IconThree cursor={'pointer'} size={'20px'} className='dark:text-darkBg-mainText'/>
            </Link>
          </Tooltip>
        )}
      </div>
    </>
  );
};

export default ThreeIcons